export const GET_FILES = 'GET_FILES';
export const DELETE_FILE = 'DELETE_FILE';
export const UPLOAD_FILE_PROGRESS = 'UPLOAD_FILE_PROGRESS';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const LOADING_FILES = 'LOADING_FILES';
export const START_FILE_UPLOAD = 'START_FILE_UPLOAD';
export const STOP_FILE_UPLOAD = 'STOP_FILE_UPLOAD';
